module.exports = __webpack_public_path__ + "img/packaging.ce6ea394.png";